(function () {
  const toggleTwoPanels = $("#toggle-two-panels-btn");
  const toggleSinglePanel = $("#toggle-single-panel-btn");
  const toggleLabel = $("#toggle-quantity-label");

  const productData = JSON.parse($("[data-product-json]").html());
  const variantsData = productData.variants;
  const variantsInventoryData = JSON.parse($("[data-variants-inventory-json]").html());
  const formVariantId = $("input[data-form-variant-id]");
  const formQuantityLabel = $("input[data-quantity-field]");
  const formQuantityInput = $('input[name="quantity"]');
  const sizeSelector = $('ul[data-popout-list-size] li');
  const curSelectedSize = $('.select-popout__itemselect-popout__item--current')
  const toggleSize = $('.select-popout__toggle--size');
  const addToCart = $('.product__submit__add');
  const errorForm = $('.product__form__errors');
  let disclosureOption = $('.disclosure-size');
  let disclosureQty = $('.disclosure-qty');
  let disclosurePrice = $('.disclosure-price');
  const disclosureAddToCart = $('.disclosure-add-btn-wrapper .product__submit__add');
  const productPrice = $('.product__price--custom');
  const comparePrice = $('[data-compare-price-custom]');
  const regPrice = $('[data-regular-price]');
  const panelPrice = $('[data-panel-price]');
  const measurementWidth = $('[data-measurement-width]');
  const measurementHeight = $('[data-measurement-height]');
  const popoutOption = $('[data-popout-option]');
  const itemQty = $('.select-popout__item-qty');
  const addToCartCustom = $('[data-add-to-cart-custom]');
  const btnCustom = $('.btn--custom');
  const optionFinish = $('.select-option-finish');
  const optionSize = $('.select-option-size');
  const plusQty = $('[data-quantity-plus]');
  const minusQty = $('[data-quantity-minus]');

  displayRegularPrice();
  pricePerPanel();
  selectMultiplePanels();
  updateSafetyLockProductQty();
  var currentVariantId = parseFloat(formVariantId.val());
  updateQuantityList(currentVariantId);
  
  if (disclosureOption) dropshipDisclosureData();

  toggleTwoPanels.click(function () {
    selectMultiplePanels();
    updateSafetyLock();
    updateSafetyLockProduct();
  });

  toggleSinglePanel.click(function () {
    selectSinglePanel();
    updateSafetyLock();
    updateSafetyLockProduct();
  });

  formVariantId.change(function () {
    updateSubtotal();
    updateInventory();
    updateAddToCartState();
    updateInventoryDropship();
    updateAddToCartDropShipState();
    var currentVariantId = parseFloat(formVariantId.val());
    updateQuantityList(currentVariantId);
    $("input[name='id']").val(currentVariantId);
  });

  formQuantityLabel.change(function () {
    updateSubtotal();
    updateQuantity();
    updateAddToCartState();
    updateAddToCartDropShipState();

    selectMultiplePanels();
    updateTwoPanelsText();
    updateSafetyLock();
    updateSafetyLockProduct();
  });

  const sizes = curSelectedSize.text().trim().replaceAll(' ', '').split('X');
  const sizeData = sizes.map(item => item.slice(0, -1));
  const width = sizeData[0];
  const height = sizeData[1];

  measurementSize(width, height);

  // size selector event
  curSelectedSize.addClass('selected__size');
  popoutOption.click(function () {
    const _this = $(this);
    popoutOption.hasClass('select-option-size') || popoutOption.hasClass('select-option-finish') ? selectTwoOptions(_this) : selectSingleOption(_this);
  })

  const selectTwoOptions = (_this) => {
    if (_this.hasClass('select-option-finish')) {
      optionFinish.parent().removeClass('selected__size');
      _this.parent().addClass('selected__size');
    } else {
      optionSize.parent().removeClass('selected__size');
      _this.parent().addClass('selected__size');
    }
  }

  const selectSingleOption = (_this) => {
    const newSize = _this[0].innerText.replaceAll(' ', '').split('X');
    const newSizeData = newSize.map(item => item.slice(0, -1));
    const newWidth = newSizeData[0];
    const newHeight = newSizeData[1];

    itemQty.removeClass('selected__size');
    _this.parent().addClass('selected__size');
    displayRegularPrice();
    pricePerPanel();
    measurementSize(newWidth, newHeight);
  }

  // readymade 2 panels
  $('ul[data-list-size] li').click(function () {
    updateSafetyLockProductQty();
    const newSafetyLock = $(this)[0].dataset.safety.replaceAll('\n', '').trim();
    const selectedId = $(this)[0].dataset.variantId;
    toggleSize.attr('data-safety', newSafetyLock.trim());
    toggleSize.attr('data-variant-id', selectedId);
    updateSafetyLock();
  });

  $('a[data-item-remove]').click(function () {
    updateSafetyLockProductQty();
  });

  addToCart.click(function () {
    validateSafetyLock();
    validateSafetyLockProduct();
    closeModal();
  });

  $('input[type="checkbox"]').change(function () {
    if (this.checked) {
      disclosureAddToCart.removeClass('variant--unavailable');
      disclosureAddToCart.prop("disabled", false);
      disclosureAddToCart.addClass('btn--custom');
    } else {
      disclosureAddToCart.addClass('variant--unavailable');
      disclosureAddToCart.prop("disabled", true);
      // disclosureAddToCart.removeClass('btn--custom');
    }
  });

  const closeModal = () => {
    if ($('.product-modal')) {
      setTimeout(() => {
        $('.product-modal').css({
          'opacity': '0',
          'display': 'none'
        });
      }, 1000);
    }
  };

  function updateQuantityList(variantId) {
    const quantityList = document.querySelector('.select-quantity');
    if (!quantityList) {
      console.error("Quantity list element not found!");
      return;
    }

    const variantDataElements = document.getElementById('variant-data').children;
    const maxDisplayQuantity = 10; // Maximum number of items allowed in dropdown

    let inventory = 0;
    let isAvailable = false;

    // Find the data for the selected variant
    for (let i = 0; i < variantDataElements.length; i++) {
      const variantElement = variantDataElements[i];
      if (variantElement.getAttribute('data-variant-id') == variantId) {
        inventory = parseInt(variantElement.getAttribute('data-inventory'));
        isAvailable = variantElement.getAttribute('data-available') === 'true';
        break;
      }
    }

    // Clear existing list
    quantityList.innerHTML = '';

    if (isAvailable) {
      const maxQuantity = Math.min(inventory, maxDisplayQuantity);

      // Create new list items based on available inventory
      for (let i = 1; i <= maxQuantity; i++) {
        const listItem = document.createElement('li');
        listItem.className = 'select-popout__item' + (i === 1 ? ' select-popout__item--current' : '');

        const link = document.createElement('a');
        link.className = 'select-popout__option select-popout__option_quantity';
        link.href = '#';
        link.setAttribute('data-value', i);
        if (i === 1) link.setAttribute('aria-current', 'true');
        link.setAttribute('data-popout-option', '');  // Corrected attribute name
        
        const span = document.createElement('span');
        span.textContent = i;

        link.appendChild(span);
        listItem.appendChild(link);
        quantityList.appendChild(listItem);
      }

      // Add event listener to update the quantity input when a quantity is selected
      document.querySelectorAll('.select-popout__option_quantity').forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          const selectedQuantity = parseInt(this.getAttribute('data-value'), 10);
          
          // Update the displayed quantity on the button
          const toggleQuantityLabel = document.getElementById('toggle-quantity-label');
          if (toggleQuantityLabel) {
            toggleQuantityLabel.textContent = `${selectedQuantity}`;
          }

          // Update the hidden quantity input field value
          formQuantityInput.val(selectedQuantity);
          formQuantityLabel.val(selectedQuantity);
          updateSubtotal();

          const element = document.getElementsByClassName("select-quantity")[0];
          element.classList.remove("popout-list--visible");

          toggleQuantityLabel.setAttribute("aria-expanded", "false");
          
          
          // Remove 'current' class from all items and add to selected
          document.querySelectorAll('.select-popout__item').forEach(item => {
            item.classList.remove('select-popout__item--current');
          });
          this.parentElement.classList.add('select-popout__item--current');
        });
      });
    } else {
      // If out of stock, show a message
      const listItem = document.createElement('li');
      listItem.className = 'select-popout__item select-popout__item--out-of-stock';
      listItem.textContent = 'Out of Stock';
      quantityList.appendChild(listItem);
    }
  }




  

    // Function to update the quantity list
// function updateQuantityList(variantId) {
//     const quantityList = document.querySelector('.select-quantity');

//     // Check if quantityList element exists before modifying it
//     if (!quantityList) {
//       console.error("Quantity list element not found!");
//       return; // Exit the function if the element is not found
//     }

//     const variantDataElements = document.getElementById('variant-data').children;
//     const maxDisplayQuantity = 10; // Maximum number of items allowed in dropdown

//     let inventory = 0;
//     let isAvailable = false;

//     // Find the data for the selected variant
//     for (let i = 0; i < variantDataElements.length; i++) {
//       const variantElement = variantDataElements[i];
//       if (variantElement.getAttribute('data-variant-id') == variantId) {
//         inventory = parseInt(variantElement.getAttribute('data-inventory'));
//         isAvailable = variantElement.getAttribute('data-available') === 'true';
//         break;
//       }
//     }

//     // Clear existing list
//     quantityList.innerHTML = ''; // This line can throw an error if quantityList is null

//     if (isAvailable) {
//       const maxQuantity = Math.min(inventory, maxDisplayQuantity);

//       // Create new list items based on available inventory
//       for (let i = 1; i <= maxQuantity; i++) {
//         const listItem = document.createElement('li');
//         listItem.className = 'select-popout__item' + (i === 1 ? ' select-popout__item--current' : '');

//         const link = document.createElement('a');
//         link.className = 'select-popout__option select-popout__option_quantity';
//         link.href = '#';
//         link.setAttribute('data-value', i);
//         if (i === 1) link.setAttribute('aria-current', 'true');
//         link.setAttribute('data-popout-option', '');  // Corrected attribute name
        
//         const span = document.createElement('span');
//         span.textContent = i;

//         link.appendChild(span);
//         listItem.appendChild(link);
//         quantityList.appendChild(listItem);
//       }

//       // Add event listener to update the quantity input when a quantity is selected
//       document.querySelectorAll('.select-popout__option_quantity').forEach(option => {
//         option.addEventListener('click', function(e) {
//           e.preventDefault();
//           const selectedQuantity = parseInt(this.getAttribute('data-value'), 10);

//           // Update the displayed quantity on the button
//           const toggleQuantityLabel = document.getElementById('toggle-quantity-label');
//           if (toggleQuantityLabel) {
//             toggleQuantityLabel.textContent = `${selectedQuantity}`;
//           }

//           // Update the hidden quantity input field value
//           const quantityInput = document.querySelector('[data-popout-input]');
//           if (quantityInput) {
//             quantityInput.value = selectedQuantity;
//           }

//           // Remove 'current' class from all items and add to selected
//           document.querySelectorAll('.select-popout__item').forEach(item => {
//             item.classList.remove('select-popout__item--current');
//           });
//           this.parentElement.classList.add('select-popout__item--current');
//         });
//       });
//     } else {
//       // If out of stock, show a message
//       const listItem = document.createElement('li');
//       listItem.className = 'select-popout__item select-popout__item--out-of-stock';
//       listItem.textContent = 'Out of Stock';
//       quantityList.appendChild(listItem);
//     }
//   }

  function measurementSize(width, height) {
    measurementWidth.text(width);
    measurementHeight.text(height);
  }

  function displayRegularPrice() {
    setTimeout(() => {
      // regPrice.text(productPrice.text());
      regPrice.text(comparePrice.text());
    }, 100)
  }

  function pricePerPanel() {
    setTimeout(() => {
      panelPrice.html(productPrice.text());
    }, 100)
  }

  function selectMultiplePanels() {
    // toggleSinglePanel.removeClass("is-selected");
    // toggleTwoPanels.addClass("is-selected");
    updateQuantity();
  }

  function selectSinglePanel() {
    // toggleTwoPanels.removeClass("is-selected");
    // toggleSinglePanel.addClass("is-selected");
    updateQuantity();
    resetQuantity();
  }

  function dropshipDisclosureData() {
    updateSubtotal();
  }

  function updateSubtotal() {
    var currentVariantId = parseFloat(formVariantId.val());
    var currentQuantity = parseFloat(formQuantityLabel.val());
    var currentVariant = variantsData.find((item) => item.id === currentVariantId);

    if (currentVariant && currentQuantity) {
      var price = currentVariant.price;
      const totalPrice = ((price / 100) * currentQuantity).toFixed(2);
      $("#toggle-single-panel-price").html("$" + (price / 100).toFixed(2));
      $("#toggle-two-panels-price").html("$" + totalPrice);

      disclosureOption.html(currentVariant.title);
      disclosureQty.html(currentQuantity);
      disclosurePrice.html(totalPrice);
    }
  }

  function updateQuantity() {
    var currentQuantity = parseFloat(formQuantityLabel.val());
    formQuantityInput.val(currentQuantity);
    $("[data-current-quantity]").text(currentQuantity);
    toggleLabel.text(currentQuantity);
  }

  function updateInventory() {
    const addBtn = $("#default-add-to-cart [data-add-to-cart]");
    if (!addBtn) return;

    var currentVariantId = parseFloat(formVariantId.val());
    var currentVariant = variantsInventoryData.find((item) => item.id === currentVariantId);

    const qtyinput = $("#product-quantity-num");
    
    if (currentVariant) {
      qtyinput.attr('max', parseFloat(currentVariant.inventory_quantity));
      addBtn.attr('data-qty-original', parseFloat(currentVariant.inventory_quantity));
    }
  }

  function updateInventoryDropship() {
    const addBtn = $("#default-add-to-cart [data-add-to-cart-dropship]");
    if (!addBtn) return;

    var currentVariantId = parseFloat(formVariantId.val());
    var currentVariant = variantsInventoryData.find((item) => item.id === currentVariantId);

    if (currentVariant) {
      addBtn.attr('data-qty-original', parseFloat(currentVariant.inventory_quantity));
    }
  }

  function updateAddToCartState() {
    const addBtn = $("#default-add-to-cart [data-add-to-cart]");
    const addBtnText = $("#default-add-to-cart [data-add-to-cart] span");

    if (!addBtn) return;

    var currentQuantity = parseFloat(formQuantityLabel.val());
    var currentVariantId = parseFloat(formVariantId.val());
    const currentVariant = $(`li[data-variant-id="${currentVariantId}"]`);
    const dataInventoryEl = currentVariant.attr('data-qty');

    if (dataInventoryEl) {
      addBtn.attr('data-qty-original', parseFloat(dataInventoryEl));
    }

    var dataInventory = parseFloat(addBtn.attr('data-qty-original'));

    if (dataInventory >= currentQuantity) {
      addBtnText.text("Add to Cart");
      addBtn.attr("disabled", false);
      addBtn.removeClass("variant--unavailable");
    } else {
      addBtnText.text("Sold Out");
      addBtn.attr("disabled", "disabled");
      addBtn.addClass("variant--unavailable");
    }
  }

  function updateAddToCartDropShipState() {
    const addBtn = $("#default-add-to-cart [data-add-to-cart-dropship]");
    const addBtnText = $("#default-add-to-cart [data-add-to-cart-dropship] span");

    if (!addBtn) return;

    var currentQuantity = parseFloat(formQuantityLabel.val());
    var currentVariantId = parseFloat(formVariantId.val());
    const currentVariant = $(`li[data-variant-id="${currentVariantId}"]`);
    const dataInventoryEl = currentVariant.attr('data-qty');

    if (dataInventoryEl) {
      addBtn.attr('data-qty-original', parseFloat(dataInventoryEl));
    }

    var dataInventory = parseFloat(addBtn.attr('data-qty-original'));

    if (dataInventory >= currentQuantity) {
      addBtnText.text("Add to Cart");
      addBtn.attr("disabled", false);
      addBtn.removeClass("variant--unavailable");
    } else {
      addBtnText.text("Add to Cart");
      addBtn.attr("disabled", false);
      addBtn.removeClass("variant--unavailable");
    }
  }

  function updateTwoPanelsText() {
    var currentQuantity = parseFloat(formQuantityLabel.val());
    const pluralText = $('.plural');
    currentQuantity > 1 ? pluralText.html('s') : pluralText.html('');
  };

  function resetQuantity() {
    formQuantityInput.val(1);
    toggleLabel.text(1);
  }

  function updateSafetyLockProductQty() {
    jQuery.get('/cart.js', function (res) {
      let data = JSON.parse(res);
      data.items.forEach((item) => {
        const currentVariantId = parseFloat(formVariantId.val());
        if (currentVariantId !== item.id) return;
        const sizeSelector = $(".select-popout__toggle--size");
        const safetyLockProduct = $(".safety-lock-product");
        const safetyLockInventory = $('.select-popout__toggle--size').attr("data-qty");
        const safetyLockProdInventory = safetyLockProduct.attr("data-qty-product");
        if (safetyLockInventory) {
          const newInventory = safetyLockInventory - parseInt(item.quantity);
          sizeSelector.attr('data-qty', newInventory);
        } else if (safetyLockProdInventory) {
          const newInventory = safetyLockProdInventory - parseInt(item.quantity);
          safetyLockProduct.attr('data-qty-product', newInventory);
        }
      });
    });
  }

  function updateSafetyLock() {
    const qty = formQuantityInput.val();
    const dataSafety = $(".select-popout__toggle--size").attr("data-safety");
    if (!dataSafety) return;
    const safety_lock = parseInt(dataSafety.trim());
    if (safety_lock == 0) return;

    const addBtn = $(".product__submit__add");

    let dataInventory = $(".select-popout__toggle--size").attr("data-qty");
    if (!dataInventory) return;
    const inventory = parseInt(dataInventory.trim());
    const newInventory = inventory - qty;
    const qtySelector = $('.select-popout__toggle--qty');

    if (newInventory < safety_lock) {
      $(".product__submit__add span").text("Sold Out");
      addBtn.attr("disabled", "disabled");
      addBtn.addClass("variant--unavailable");
    } else {
      $(".product__submit__add span").text("Add to cart");
      addBtn.attr("disabled", false);
      addBtn.removeClass("variant--unavailable");
      qtySelector.attr("disabled", false);
    }
  }

  function updateSafetyLockProduct() {
    const qty = formQuantityInput.val();
    const dataSafety = $(".safety-lock-product").attr("data-safety-product");
    if (!dataSafety) return;
    const safety_lock = parseInt(dataSafety.trim());
    if (safety_lock == 0) return;
    const addBtn = $(".product__submit__add");
    let dataInventory = $(".safety-lock-product").attr("data-qty-product");
    if (!dataInventory) return;
    const inventory = parseInt(dataInventory.trim());
    const newInventory = inventory - qty;

    if (newInventory < safety_lock) {
      $(".product__submit__add span").text("Sold Out");
      addBtn.attr("disabled", "disabled");
      addBtn.addClass("variant--unavailable");
    } else {
      $(".product__submit__add span").text("Add to cart");
      addBtn.attr("disabled", false);
      addBtn.removeClass("variant--unavailable");
      addBtn.addClass('btn--custom');
    }
  }

  function validateSafetyLock() {
    const qty = formQuantityInput.val();
    const dataSafety = $(".select-popout__toggle--size").attr("data-safety");
    if (!dataSafety) return;
    const safety_lock = parseInt(dataSafety.trim());
    const addBtn = $(".product__submit__add");

    let dataInventory = $(".select-popout__toggle--size").attr("data-qty");
    if (!dataInventory) return;
    const inventory = parseInt(dataInventory.trim());
    const newInventory = inventory - qty;

    $(".select-popout__toggle--size").attr("data-qty", newInventory);

    const selectedSize = $('.select-popout__toggle--size').attr('data-variant-index');
    const productVariant = productData.variants[selectedSize];

    // if (newInventory < safety_lock) {
    //   $(".product__submit__add span").text("Sold Out");
    //   addBtn.attr("disabled", "disabled");
    //   addBtn.addClass("variant--unavailable");
    //   errorForm.addClass('is-visible');
    //   errorForm.append(errorMsg(productVariant.title));
    // } else if (newInventory == safety_lock) {
    //   setTimeout(() => {
    //     $("span[data-add-to-cart-custom]").text("Sold Out");
    //     addBtn.attr("disabled", "disabled");
    //     addBtn.addClass("variant--unavailable");
    //   }, 3000);
    // } else {
    //   setTimeout(() => {
    //     $("span[data-add-to-cart-custom]").text("Add to cart");
    //     addBtn.attr("disabled", false);
    //     addBtn.removeClass("variant--unavailable");
    //     addBtn.removeClass("variant--unavailable-overlay");
    //     addBtn.addClass('btn--custom');
    //   }, 3000);
    // }
  };

  function validateSafetyLockProduct() {
    const qty = formQuantityInput.val();
    const dataSafetyProduct = $(".safety-lock-product").attr("data-safety-product");

    if (!dataSafetyProduct) return;
    const safety_lock_product = parseInt(dataSafetyProduct.trim());
    const addBtn = $(".product__submit__add");

    let dataInventory = $(".safety-lock-product").attr("data-qty-product");
    if (!dataInventory) return;
    const inventory = parseInt(dataInventory.trim());
    const newInventory = inventory - qty;

    $(".safety-lock-product").attr("data-qty-product", newInventory);

  //   if (newInventory < safety_lock_product) {
  //     $(".product__submit__add span").text("Sold Out");
  //     addBtn.attr("disabled", "disabled");
  //     addBtn.addClass("variant--unavailable");
  //     errorForm.addClass('is-visible');
  //     errorForm.append(errorMsg());
  //   } else {
  //     $(".product__submit__add span").text("Add to cart");
  //     addBtn.attr("disabled", false);
  //     addBtn.removeClass("variant--unavailable");
  //   }
  };

  errorForm.click(function () {
    errorForm.removeClass('is-visible');
  });

  const errorMsg = (variant) => {
    return `
      <div class="errors">
        Cart Error: All ${productData.title} ${variant ? `- ${variant}` : ''} are in your cart
        <span class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><g stroke="#979797" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M.5.5l26 26M26.5.5l-26 26"></path></g></svg></span>
      </div>
    `
  };

  const disabledAddToCart = () => {
    if (addToCart.is('[disabled=disabled]')) {
      // addToCart.removeClass('btn--custom');
    }
  };

  disabledAddToCart();
})();
